import { TypeIdSchema } from '@unipile/db';
import { Static, Type } from '@sinclair/typebox';

export const ReplayEventParamsSchema = Type.Object({ id: TypeIdSchema('event') });

export const ReplayEventQuerySchema = Type.Object({
  endpoint_id: Type.Optional(
    TypeIdSchema('webhookEndpoint', {
      description:
        'Replay only to this original endpoint. Omit to replay to all currently enabled endpoints listening to this event and matching its account.',
    }),
  ),
});

export type ReplayEventQuery = Static<typeof ReplayEventQuerySchema>;
